var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box has-padding-300 has-text-centered content"},[_c('h3',{staticClass:"is-size-3"},[_vm._v("Application unavailable.")]),_c('p',[_vm._v(" Unfortunately this application is not available from the hostname "),_c('strong',[_vm._v(_vm._s(_vm.hostname))]),_vm._v(". ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }